import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { DataService } from '@services/ops-profiledata.service';
import { GlobalErrorService } from '@services/global-error.service';
import { ContractorHeadCount } from '@interfaces/vendor-profile.model';
import { AuthService } from '@core/auth.service';
import { ActivatedRoute } from '@angular/router';
import { VendorProfile, vendorProfileMetrics } from '@app/shared/constants/global.enum';
import { generateLast12MonthsVendor } from '@shared/utils/utils'

@Component({
  selector: 'app-contractor-vendor-head-count',
  templateUrl: './app-contractor-vendor-head-count.component.html',
  styleUrls: ['./app-contractor-vendor-head-count.component.scss'],
})
export class ContractorVendorHeadCountComponent implements OnInit {
  vendorProfile = VendorProfile;
  monthOptions: { value: string; label: string; month: string; year: string, selected?: boolean }[] = [];
  selectedMonth: string = '';
  selectedYear: string = '';
  totalCount: number = 0;
  isDataLoaded: boolean = false;
  errorMsg: string = '';
  displayData: ContractorHeadCount[] = [];
  metrics: { label: string; key: keyof ContractorHeadCount }[] = [
    { label: vendorProfileMetrics.TotalContractors, key: 'totalContractors' },
    { label: vendorProfileMetrics.HyderabadContractors, key: 'hyderabadContractors' },
    { label: vendorProfileMetrics.NcrContractors, key: 'ncrContractors' },
    { label: vendorProfileMetrics.RemoteContractors, key: 'remoteContractors' },
  ];

  @Input() vendorId: string | null = null;

  constructor(
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private errorHandler: GlobalErrorService,
    private authService: AuthService,
    private route: ActivatedRoute
  ) {}
  ngOnInit(): void {

    this.monthOptions = generateLast12MonthsVendor();

    const preSelectedOption = this.monthOptions.find((option => option.selected));
    if (preSelectedOption) {
      this.selectedMonth = preSelectedOption.month;
      this.selectedYear = preSelectedOption.year;
    }
    if (this.vendorId) {
      this.loadVendorData();
    }
  }
  loadVendorData(): void {
    if (!this.vendorId) return;
    this.dataService
      .getContractorHeadCount(this.vendorId, this.selectedMonth, this.selectedYear)
      .subscribe({
        next: (response) => {
          this.displayData = response.data || [];
          this.totalCount = this.displayData.length;
          this.isDataLoaded = true;
          this.cdr.detectChanges();
        },
        error: () => {
          this.errorMsg = this.vendorProfile.failedToLoadContractorHeadCount;
          this.isDataLoaded = true;
          this.displayData = [];
          this.totalCount = 0;
          this.cdr.detectChanges();
        },
      });
  }

  onMonthChange(event: any): void {
    let selectedValue: string | undefined;
    if (typeof event === 'string') {
      const monthOption = this.monthOptions.find(option => option.label === event);
      selectedValue = monthOption ? monthOption.value : undefined;
    } else if (event.value) {
      selectedValue = event.value;
    }
    if (!selectedValue || !this.monthOptions.some(option => option.value === selectedValue)) {
      this.errorHandler.showError(this.vendorProfile.invalidMonthSelected);
      return;
    }
    const selectedOption = this.monthOptions.find(option => option.value === selectedValue);
    if (selectedOption) {
      this.selectedMonth = selectedOption.month;
      this.selectedYear = selectedOption.year;
      this.loadVendorData();
    }
  }
}
